// TODO: add better ui for page not found
import React, { Component } from "react";
import { isAndroid } from "react-device-detect";

class MobileWebLanding extends Component {
  componentDidMount() {
    if (isAndroid) {
      window.open(
        "https://play.google.com/store/apps/details?id=com.unifize.chat",
      );
    }
  }
  render() {
    return <div />;
  }
}

export default MobileWebLanding;
